import React from "react";
import { css } from "@emotion/core";

const heroStyles = css`
  width: 100%;
  height: auto;

  & > img {
    width: 100%;
    height: auto;
    object-fit: fill;
  }
`;

const FullWidthImage = ({ src, alt, ...rest }) => {
  return (
    <div css={heroStyles} {...rest}>
      <img src={src} alt={alt} />
    </div>
  );
};

export default FullWidthImage;
